import { getEnv } from '../../utils/constants';

type SlackMrkdwnText = {
  type: 'mrkdwn';
  text: string;
};

type SlackSectionBlock = {
  type: 'section';
  text: SlackMrkdwnText;
};

type SlackDividerBlock = {
  type: 'divider';
};

type SlackBlock = SlackSectionBlock | SlackDividerBlock;

export type SlackMessagePayload = {
  payload: { text: string; blocks?: SlackBlock[] };
};

const env = getEnv();
export const getPasswordResetEmail = (email: string) => {
  return {
    text: `Password reset requested for ${email} on *${env}*`,
  };
};

const LAMBDA_URL =
  'https://qi5nyi6i4nbm7bcgoze6isxote0yfxhf.lambda-url.us-west-2.on.aws/';

export const sendSlackMessage = async (
  payload: { text: string } | SlackMessagePayload,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  try {
    const res = await fetch(LAMBDA_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // 'Content-Length': Buffer.byteLength(body).toString(),
      body: JSON.stringify(payload),
    });
    if (res.status !== 200) {
      return {
        success: false,
        error: {
          message: 'Something went wrong while sending the request',
        },
      };
    }
    const data = await res.json();
    return { success: true, data };
  } catch (e) {
    return {
      success: false,
      error: {
        message: 'Something went wrong while sending the request',
      },
    };
  }
};
